import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { m } from "@/paraglide/messages.js";

/** Availability is a tab of the setup page now. Old links and bookmarks land on it. */
export const Route = createFileRoute("/(private)/booking/availability/")({
  loader: () => ({ crumb: m.booking_availability_page_title() }),
  validateSearch: z.object({ bookingId: z.string().optional() }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/booking/setup",
      search: { tab: "availability", bookingId: search.bookingId },
      replace: true,
    });
  },
});
